import { render, staticRenderFns } from "./BuyerCampaignTrafficControl.vue?vue&type=template&id=2a30137f&scoped=true"
import script from "./BuyerCampaignTrafficControl.vue?vue&type=script&lang=ts"
export * from "./BuyerCampaignTrafficControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a30137f",
  null
  
)

export default component.exports